export default {
  methods: {
    handleMapReady() {},
  },
  mounted() {
    this.$amap = this.$amap || this.$parent.$amap
    if (this.$amap) {
      let mapManager = this.$mapManager
      this.handleMapReady(this.$amap, mapManager)
    } else {
      this.$on('mapReady', this.handleMapReady)
    }
  },
  beforeDestroy() {
    this.$off('mapReady')
  },
}
